<div id="loadingOverlay" class="overlay" *ngIf="isLoading">
  <div class="overlay-content">
    <div class="logo-container">
      <img [src]="logoUrl" alt="Logo" width="250" />
    </div>
    <div class="loader">
      <div class="dot" *ngFor="let dot of dots"></div>
    </div>
    <div class="loading-message">{{ loadingMessage }}</div>
   
  </div>
</div>
